<header
  class="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur supports-backdrop-filter:bg-white/80">
  <div class="flex h-16 items-center gap-1 sm:gap-3 px-3 sm:px-4 lg:px-6">
    <!-- Menu button -->
    <button
      mat-icon-button
      type="button"
      (click)="onMenuClick()"
      aria-label="open menu"
      class="shrink-0">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Brand -->
    <a
      [href]="`/${currentUrlLang()}/home`"
      class="flex min-w-0 items-center gap-3 rounded-2xl px-2 py-1 pr-4 transition hover:bg-slate-100"
      [attr.title]="appName | translate">
      <img [src]="logoUrl" alt="Logo" class="w-[160px] object-contain sm:w-[180px] md:w-[200px]" />
    </a>

    <div class="flex-1"></div>
    <!-- Language selector -->
    <div class="relative">
      <app-language-selector />
    </div>

    <!-- User info desktop -->
    <div class="hidden md:block text-right">
      <p class="truncate text-sm font-semibold text-slate-800">
        {{ userName }}
      </p>
      <p class="truncate text-xs text-slate-500">
        {{ roleName | translate }}
        @if (personNumber) {
          <span>· #{{ personNumber }}</span>
        }
      </p>
    </div>

    <!-- User menu -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      aria-label="Menú de usuario"
      class="rounded-full border border-slate-200">
      <mat-icon>account_circle</mat-icon>
    </button>

    <mat-menu #userMenu="matMenu">
      <div class="px-4 py-3 md:hidden">
        <p class="text-sm font-semibold text-slate-800">{{ userName }}</p>
        <p class="text-xs text-slate-500">
          {{ roleName }}
          @if (personNumber) {
            <span>· #{{ personNumber }}</span>
          }
        </p>
      </div>

      <button mat-menu-item type="button" (click)="onLogout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'shell.actions.logout' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</header>
